import script from "./DiscontinueModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscontinueModal.vue?vue&type=script&setup=true&lang=ts"

import "./DiscontinueModal.vue?vue&type=style&index=0&id=75689ef1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75689ef1"]])

export default __exports__